import { useEffect, useState, useContext } from 'react'
import Layout from "../../../components/layout"
import { HeaderWrapper, ContentWrapper } from './style'
import Pagination from '../../../components/pagination';
import { getRolesApi, deleteRoleApi } from '../../../api'
import { AuthContext } from '../../../context/auth';
import moment from 'moment/moment';
import DeleteRoleModal from "../../../components/modals/DeleteRoleModal"
import AddRoleModal from "../../../components/modals/addRoleModal"
import { mapPermissionsToLabels } from '../../../utils/permissions';

const Index = () => {
  const { setIsLoading, setNotification } = useContext(AuthContext)
  const [roles, setRoles] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [deleteRoleModal, setDeleteRoleModal] = useState(false)
  const [openRoleModal, setOpenRoleModal] = useState(false)
  const [selectedRole, setSelectedRole] = useState(null)

  const fetchRoles = () => {
    setIsLoading(true)
    getRolesApi(10, currentPage * 10).then(res => {
      if (res && res.data) {
        setRoles(res?.data)
        setIsLoading(false)
      }
    }).catch(err => {
      console.error(err)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    fetchRoles()
  }, [currentPage])


  const onDeleteRole = () => {
    setIsLoading(true)
    deleteRoleApi(selectedRole?.id).then(res => {
      if (res && res.data) {
        fetchRoles()
        setDeleteRoleModal(false)
        setOpenRoleModal(false)
        setSelectedRole(null)
        setIsLoading(false)
        setNotification({ type: 'success', message: 'Role deleted successfully' })
      }
    }).catch(err => {
      setIsLoading(false)
      setNotification({ type: 'error', message: 'Something went wrong' })
    })
  }


  return (
    <Layout>
      <HeaderWrapper>
        <div className="header-title"><span className='sub-title'>Roles</span>{roles?.count}</div>
        <div className="header-search-container">
          <button className='btn' onClick={() => setOpenRoleModal(true)}>Add New Role</button>
        </div>
      </HeaderWrapper>
      <ContentWrapper>
        {roles && roles?.count > 0 ? <>
          <table className={"mainTable"}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Permissions</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {roles?.roles?.map((data) => {
                const permissions = mapPermissionsToLabels(data?.permissions[0]?.metadata);
                return (
                  <tr
                    key={data?.id}
                  >
                    <td>
                      <strong>{data?.name}</strong>
                    </td>
                    <td className='permissions-container'>
                      {permissions.map(p => (
                        <div key={p.category} className='permissions'>
                          <strong>{p.category}:</strong>
                          {p.labels.map((label, index) => (
                            <span className='permission-label' key={index}>{label}</span>
                          ))
                          }
                        </div>
                      ))}
                    </td>
                    <td>
                      {data?.created_at ? moment(data?.created_at).format('MMMM DD, YYYY, h:mm A') : "-"}
                    </td>
                    <td style={{ cursor: "pointer" }}>
                      <span style={{ display: 'flex', gap: '30px', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <button style={{ fontSize: '16px', color: '#6c6a73' }} onClick={() => {
                          setSelectedRole(data)
                          setOpenRoleModal(true)
                        }}><i class="fal fa-pencil"></i></button>
                        {/* <button style={{ fontSize: '16px', color: '#6c6a73' }}
                          onClick={() => {
                            setSelectedRole(data)
                            setDeleteRoleModal(true)
                          }}
                        ><i class="fal fa-trash-alt"></i></button> */}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {roles?.count / roles?.limit > 1 && <Pagination total={roles?.count / roles.limit} setCurrentPage={setCurrentPage} currentPage={currentPage} />}
        </>
          : <div className='no-orders'>
            <span className='icon'>
              <i class="far fa-boxes"></i>
            </span>
            <p>No roles found.</p>
          </div>
        }
      </ContentWrapper>
      {openRoleModal && <AddRoleModal setOpenRoleModal={setOpenRoleModal} selectedRole={selectedRole} setSelectedRole={setSelectedRole} fetchRoles={fetchRoles} setDeleteRoleModal={setDeleteRoleModal} existingMetadata={selectedRole?.permissions[0]?.metadata} />}
      {(deleteRoleModal && selectedRole) && <DeleteRoleModal selectedRole={selectedRole} setSelectedRole={setSelectedRole} setDeleteRoleModal={setDeleteRoleModal} onDeleteRole={onDeleteRole} />}
    </Layout>
  )
}

export default Index